// 状态
const state = {
    "preheatIng": "Đang làm nóng trước",
    "purchaseIng": "Đang mua sắm",
    "process": "Đang tiến hành",
    "over": "Đã kết thúc",
    "finish": "Đã hoàn thành",
    "noData": "Chưa có dữ liệu"
};
  
  //抢购区和个人抢购记录页上方的subheader
  const subheader = {
    "pricePromise": "Cam kết giá, không bao giờ giảm giá",
    "vipPrice": "Hoàn tiền VIP, giá ưu đãi",
    "protection": "Bảo vệ duy nhất theo đồng tiền pháp định",
    "pricePromiseVal": "Bảo giá trong [*] ngày, không bao giờ giảm giá",
    "rewards": "Lợi nhuận [*]%, cam kết bảo giá",
    "vipDis": "Ưu đãi VIP, mua sắm có lời",
    "zlz": "Đang hỗ trợ"
  };
  
  // 抢购区
  const purchase = {
    "periods": "Kỳ thứ [*]",
    "timesSheaves": "Lượt thứ [*]",
    "supportPic": "[*] ngày giữ giá, không bao giờ giảm giá",
    "earnings": "Lợi nhuận [*]%, cam kết giữ giá",
    "vipDiscount": "Ưu đãi VIP, mua sắm có lời",
    "limit": "Số lượng giới hạn trong vòng này",
    "timeLimit": "Giá giới hạn thời gian",
    "schedule": "Tiến độ hiện tại",
    "finishHalf": "Đã hoàn thành [*]%",
    "subscriptionNum": "Số lượng mua sắm",
    "vipText": "（VIP[*]）thưởng mua sắm（[**] [***] [****] giảm giá）",
    "supportType": "Phương thức giữ giá: Trong thời gian giữ giá, BiKing sẽ đặt một lệnh mua vào thị trường phụ với giá giữ giá thấp nhất, người dùng có thể chọn bán trong thời gian giữ giá hoặc không. Sau khi kết thúc thời gian giữ giá, các lệnh mua giữ giá tối thiểu liên quan sẽ bị hủy.",
    "beAbouttoAlipay": "Sắp mở mạng",
    "atOnceAlipay": "Mua ngay",
    "atOnceAlipayNew": "Hỗ trợ ngay",
    "atOnceAlipayed": "Bạn đã mua sắm, hãy chú ý đến vòng tiếp theo",
    "atOnceAlipayedOver": "Bạn đã mua sắm, không thể mua sắm lại",
    "atOnceAlipayedNew": "Bạn đã hỗ trợ, hãy chú ý đến vòng tiếp theo",
    "atOnceAlipayedNewOver": "Bạn đã hỗ trợ, không thể tham gia lại",
    "website": "Trang web",
    "whitePaper": "Sách trắng",
    "foreshow": "Thông báo trước",
    "startToUp": "Bắt đầu mua sắm",
    "startToUpNew": "Bắt đầu hỗ trợ",
    "distanceStartToUp": "Còn lại thời gian mở mạng",
    "num": "Tích lũy hiện tại（[*]） Người đã mua sắm（[**] BAT）",
    "bannerText": "[*] Mua sắm được [**] giới hạn",
    "bannerTextNew": "[*] Hỗ trợ được [**] giới hạn",
    "nextProject": "Giới hạn của bạn đã được mua sắm hết, hãy chú ý đến dự án tiếp theo",
    "timesText": "Tất cả trong vòng này đã bán hết, tiếp theo là vào [*] tháng [**] ngày [***] giờ [****] phút [*****] giây",
    "times": "[*] ngày [**] giờ [***] phút [****] giây",
    "viewDetail": "Xem chi tiết",
    "completePawd": "Hoàn thành cài đặt mật khẩu giao dịch cho tài khoản của bạn",
    "sureCoins": "Đảm bảo rằng lượng tiền trong tài khoản của bạn lớn hơn [*] [**]（lượng mua tối thiểu）",
    "sureBalance": "Đảm bảo rằng số dư trong tài khoản của bạn lớn hơn [**]",
    "set": "Điều chỉnh",
    "available": "Số lượng có sẵn để mua sắm",
    "holding": "Lượng giữ trong tài khoản",
    "startSoon": "Mua sắm sắp bắt đầu",
    "startSoonNew": "Hỗ trợ sắp bắt đầu",
    "projectSupp": "Số lượng dự án",
    "projectSuppNew": "Giới hạn hỗ trợ",
    "successBuy": "Mua sắm thành công",
    "successBuyNew": "Hỗ trợ thành công",
    "projectLimit": "Còn lại đến khi dự án bắt đầu",
    "subscription": "Mua sắm thành công",
    "subscriptionNew": "Hỗ trợ thành công",
    "projectGoal": "Tổng số lượng dự án mua sắm này",
    "projectGoalNew": "Tổng số lượng dự án hỗ trợ này",
    "goalFunds": "Hiện tại đã mua sắm được",
    "goalFundsNew": "Hỗ trợ thực hiện đạt được mục tiêu"
  };
  
  //抢购条件
  
  const purchaseCondition = {
    "q": " và ",
    "h": " hoặc ",
    "cztj": "Đảm bảo số lượng nạp tiền",
    "wqyh": "Giới hạn người dùng chưa tham gia hoạt động liên quan trong quá khứ",
    "vipdj": "Giới hạn người dùng VIP[*] và cao hơn",
    "condition": "Điều kiện mua sắm",
    "conditionNew": "Điều kiện hỗ trợ",
    "nameverify1": "Hoàn tất xác minh KYC tại Trung Quốc đại lục",
    "nameverify2": "Hoàn tất xác minh KYC tại nước ngoài Trung Quốc đại lục",
    "nameverify3": "Hoàn tất xác minh KYC của BiKing",
    "login": "Vui lòng đăng nhập",
    "maxBuyin": "Mua vào tối đa",
    "verify": "Điều kiện xác minh KYC",
    "affirm": "Đảm bảo lượng giữ trong tài khoản lớn hơn [*]",
    "myPosition": "Vị trí của tôi",
    "AmountOfAscension": "Số lượng mua sắm được",
    "AmountOfAscensionNew": "Số lượng hỗ trợ được",
    "AmountOfAscensionText": "Trong vòng 7 ngày trước vòng 1, mức giữ trung bình hàng ngày càng cao, số lượng mua sắm của bạn càng nhiều",
    "AmountOfAscensionTime": "Mức giữ trung bình hàng ngày của tôi trong 7 ngày trước đó [*]",
    "discount": "Giảm giá khi mua sắm",
    "vip_discount": "Giảm giá khi hỗ trợ",
    "discountText": "Càng cao cấp VIP, giá mua sắm càng thấp",
    "upgrade": "Nâng cấp ngay",
    "vipUpgrade": "VIP của tôi",
    "zled": "Số lượng hỗ trợ",
    "wdzl": "Vị trí hỗ trợ của tôi",
    "zlxm": "Dự án hỗ trợ",
    "mlzl": "Mỗi vòng hỗ trợ",
    "zlmx": "Chi tiết hỗ trợ",
    "ccff": "Phát hành lần đầu",
    "qgmx": "Chi tiết mua sắm",
  
    "fjtj": "Điều kiện bổ sung",
    "guoji": "Quốc tịch",
    "noJoin": "Không hỗ trợ tham gia",
    "wancheng": "Hoàn thành",
    "pinggu": "Bảng đánh giá rủi ro đầu tư tiền điện tử",
    "cyhd": "Tham gia hoạt động"
  };
  
  // 历史项目
  const historyProject = {
    "rushLimit": "Số lượng mua sắm được",
    "averagePic": "Giá trung bình",
    "averageNum": "Số người mua sắm trung bình"
  };
  
  // 支付
  const alipay = {
    "alipaynum": "Số lượng mua sắm",
    "alipaynumNew": "Số lượng hỗ trợ",
    "ShouldPay": "Phải thanh toán",
    "VipDiscounts": "Ưu đãi VIP",
    "VipWin": "Ưu đãi thành viên win",
    "willOpen": "Sắp mở",
    "actualPayment": "Thanh toán thực tế",
    "actualPaymentNew": "Hỗ trợ trong vòng này",
    "importPassword": "Nhập mật khẩu giao dịch",
    "forGetPassword": "Quên mật khẩu giao dịch?",
    "promptlyAlipay": "Thanh toán ngay",
    "purchaseSuccess": "Chúc mừng bạn, mua sắm thành công",
    "purchaseSuccessNew": "Chúc mừng bạn, hỗ trợ thành công",
    "purchaseError": "Xin lỗi, mua sắm thất bại, vui lòng làm mới trang và thử lại"
  };
  // 项目详情
  const projectDetails = {
    "text": "Đảm bảo giữ lượng trong tài khoản lớn hơn [*][**]",
    "timelimitPic": "Giá giới hạn thời gian",
    "subscriptionLimit": "Số lượng mua sắm được",
    "subscriptionLimitNew": "Số lượng hỗ trợ được",
    "preheat": "Tiền khởi động",
    "supportAbort": "Thời gian giữ giá kết thúc",
    "unlockAbort": "Thời gian phát hành",
    "projectIntroduction": "Giới thiệu dự án",
    "projectRole": "Quy tắc hoạt động",
    "rule": "Quy tắc mua sắm",
    "ruleNew": "Quy tắc hỗ trợ"
  };
  // 抢购结束
  const purchaseOver = {
    "haveSubscribed": "Số lượng mua sắm đã thành công",
    "schedule": "Tiến độ hiện tại",
    "Stime": "Thời gian bắt đầu mua sắm",
    "StimeNew": "Thời gian bắt đầu hỗ trợ",
    "Etime": "Thời gian kết thúc mua sắm",
    "EtimeNew": "Thời gian kết thúc hỗ trợ",
    "successText": "Dự án này có mức tài trợ là [*] BAT, và đã đạt được mục tiêu tài trợ. Quá trình tài trợ đã thành công!",
    "success": "Thành công"
  };
  // 我的抢购
  const myPurchase = {
    "endUnlock": "Vòng mua sắm cuối cùng kết thúc mở khóa",
    "endUnlock2": "Vòng mua sắm cuối cùng kết thúc và phát hành",
    "LText": "Mở khóa hàng ngày trong thời gian giữ giá",
    "WText": "Mở khóa hàng ngày ngoài thời gian giữ giá",
    "unlockend": "Đã mở khóa",
    "record": "Chi tiết mua sắm",
    "myPurchaseName": "Dự án mà tôi đã tham gia"
  };
  
  //mHeader
  const mHeader = {
    "sy": "Trang chủ",
    "ksjy": "Giao dịch nhanh",
    "zyjy": "Giao dịch chuyên nghiệp",
    "c2c": "Giao dịch C2C",
    "otc": "Giao dịch OTC",
    "zczx": "Trung tâm tài sản",
    "xwgg": "Thông báo tin tức",
    "xwgg1": "Thông báo",
    "lc": "BiKing Earn",
    "gxlc": "Đầu tư lợi suất cao",
    "dxjh": "FansUp!",
    "fbjy": "Mua tiền",
    "dl": "Đăng nhập",
    "zc": "Đăng ký",
    "jtzw": "Tiếng Trung giản thể",
    "ftzw": "Tiếng Trung phồn thể",
    "english": "English",
    "kr": "한국어",
    "qgms": "Mua sắm giây",
    "xsjy": "Giao dịch tiềm năng",
    "zczgz": "Tổng giá trị tài sản",
    "yhzx": "Trung tâm người dùng",
    "wdgl": "Quản lý lệnh chờ",
    "tc": "Thoát tài khoản",
    "dltq": "Khu vực lưu thông thấp",
    "sdgm": "Mua sắm siêu nhanh",
    "appdown": "Tải ứng dụng",
    "appdown1": "Tải",
    "biking": "Ứng dụng BiKing",
    "gfqb": "Ví chính thức",
    "xzbyapp": "Tải ứng dụng BiKing",
    "xzbyapp2": "Tải ứng dụng BiKing",
    "smewm": "Quét mã hai chiều",
    "xzhyqb": "Tải ví HyperPay",
    "xzhyqb2": "Tải ví HyperPay",
    "bbjy": "Giao dịch tiền điện tử",
    "hyjy": "Hợp đồng vĩnh viễn", //"Giao dịch hợp đồng",
    "eftjy": "Giao dịch ETF",
    "byb": "Kiếm tiền",
    "newPos": "Hồ bơi khai thác HBT",
    "HyperPay": "Kiếm tiền HyperPay",
    "hqlc": "Đào mỏ POS",
    "newlc": "Kiếm tiền",
    "dd": "Đơn đặt hàng",
    "zichan": "Tài sản",
    "xxzx": "Trung tâm thông báo",
    "zhyaq": "Tài khoản và An toàn",
    "sfyz": "Xác thực danh tính",
    "wdvip": "VIP của tôi",
    "apigl": "Quản lý API",
    "hdzx": "Trung tâm sự kiện",
    "wdhb": "Hồ bảo của tôi",
    "flzx": "Trung tâm phúc lợi",
    "bitloan": "BiKing Bảo",
    "ggjy": "Giao dịch đòn bẩy",
    "hyxy": "Học viện",
    "flhd": "Sự kiện phúc lợi",
    "bitWin": "BiKing Bảo",
};
  
  //res
  const res = {
    "seckill_project_000": "Hệ thống bất thường",
    "seckill_project_001": "Không có dự án khả dụng",
    "seckill_project_002": "Thông tin dự án không tồn tại",
    "seckill_userInfo_001": "Người dùng không tồn tại",
    "i18n_no_table_001": "Hệ thống đang bận rộn",
    "seckill_record_1": "Thanh toán thất bại",
    "seckill_7days_1": "Dự án hiện tại không có quy tắc giữ trong 7 ngày",
    "seckill_wallet_1": "Hệ thống đang bận rộn",
    "seckill_wallet_2": "Số dư ví không đủ",
    "seckill_wallet_3": "Thanh toán thất bại",
    "seckill_record_count_1": "Lỗi dữ liệu",
    "seckill_record_count_2": "Thanh toán thất bại",
    "seckill_record_count_3": "Thanh toán thất bại",
    "seckill_rounds_1": "Hệ thống đang bận rộn",
    "seckill_rounds_2": "Trong dự án hiện tại, không có vòng nào đang được mua sắm",
    "seckill_rounds_3": "Trong dự án hiện tại, không có thông tin vòng nào",
    "seckill_rounds_4": "Hệ thống đang bận rộn",
    "seckill_rounds_5": "Trong dự án hiện tại, không có thông tin vòng cụ thể nào",
    "seckill_pro_1": "Không tìm thấy thông tin dự án",
    "seckill_pro_2": "Số lượng mua sắm ít hơn số lượng mua tối thiểu",
    "seckill_pro_4": "Hệ thống đang bận rộn",
    "seckill_pro_5": "Dự án không ở trạng thái bán",
    "seckill_pay_1": "Hệ thống đang bận rộn",
    "seckill_pay_2": "Hệ thống đang bận rộn",
    "seckill_pay_3": "Không tìm thấy thông tin dự án",
    "seckill_pay_4": "Số lượng mua sắm ít hơn số lượng mua tối thiểu",
    "seckill_pay_5": "Số lượng mua sắm vượt quá số lượng còn lại trong vòng này",
    "seckill_pay_6": "Không có số lượng mua sắm",
    "seckill_pay_7": "Số lượng mua sắm lớn hơn số lượng mua sắm",
    "seckill_pay_8": "Hệ thống đang bận rộn",
    "seckill_pay_9": "Mật khẩu giao dịch sai",
    "seckill_pay_10": "Thanh toán thất bại, vui lòng mua lại",
    "seckill_pay_11": "Thanh toán thất bại, vui lòng mua lại",
    "seckill_pay_12": "Lỗi thông tin người dùng",
    "seckill_pay_13": "Thanh toán thất bại",
    "seckill_pay_14": "Mật khẩu giao dịch sai",
    "seckill_pay_15": "Hệ thống đang bận rộn",
    "seckill_pay_16": "Đã hết số lượng mua sắm",
    "seckill_pay_17": "Xin lỗi, số lượng người xếp hàng mua sắm quá nhiều, vui lòng thử lại",
    "seckill_pay_18": "Vòng này đã mua sắm xong",
    "seckill_pay_19": "Vòng này đã mua sắm xong",
    "seckill_pay_20": "Vui lòng đăng nhập trước",
    "seckill_pay_21": "Vui lòng hoàn thành xác minh danh tính trước",
    "seckill_pay_22": "Chỉ có người dùng KYC Trung Quốc lục địa mới có thể mua sắm dự án này",
    "seckill_pay_23": "Chỉ có người dùng KYC ngoại Trung Quốc lục địa mới có thể mua sắm dự án này",
    "seckill_pay_24": "Số lượng lần nhập mật khẩu giao dịch sai đã vượt quá, vui lòng thử lại sau",
    "seckill_hold_1": "Số lượng [*] bạn đang giữ chưa đạt đến điều kiện tham gia, vui lòng mua sắm để tham gia",
    "seckill_survey_submited": "Bạn đã gửi khảo sát này trước đó",
    "seckill_survey_error": "Xử lý thông tin khảo sát gặp sự cố",
    "seckill_survey_info": "Trong dự án hiện tại, không có thông tin khảo sát nào được tìm thấy"
  };
  
  const addContent = {
    hdjshy:'Sự kiện đã kết thúc',
    "qgsj": "Thời gian mua sắm",
    "qgsjNew": "Thời gian hỗ trợ",
    "gz": "Quy tắc",
    "zdjg": "Giá tối thiểu",
    "sq": "Thu gọn",
    "qgms": "Mua sắm giây",
    "rgxm": "Tham gia dự án",
    "bled": "Số tiền trong vòng này",
    "dqjd": "Tiến độ hiện tại",
    "yjs": "Đã mở khóa",
    "yff": "Đã phát hành",
    "qbcc": "Giữ chỗ",
    "cg": "Vượt qua",
    "jxmks": "Dựa vào dự án bắt đầu, còn lại",
    "ycgrg": "Đã mua sắm thành công",
    "cgrg": "Mua sắm thành công",
    "xmed": "Số tiền dự án",
    "cxmck": "Số tiền mục tiêu quyên góp của dự án",
    "ckmb": "Dự án đã đạt được số tiền quyên góp mục tiêu",
    "ck": "Quyên góp",
    "ckxq": "Xem chi tiết",
    "kqed": "Số tiền có thể mua sắm",
    "zhcc": "Số lượng giữ chỗ trong tài khoản",
    "jjks": "Sắp bắt đầu mua sắm",
    "mmsz": "Hoàn thành cài đặt mật khẩu giao dịch cho tài khoản của bạn",
    "qsz": "Đi đến cài đặt",
    "qbye": "Đảm bảo số dư trong tài khoản của bạn là hơn [**]",
    "zjcz": "Đảm bảo số lượng giữ chỗ của bạn là hơn [**] [**] (số lượng mua tối thiểu)",
    "jgdb": "Bảo đảm giá, không bao giờ giảm",
    "jgyh": "Hỗ trợ VIP, giá ưu đãi",
    "bwbj": "Bảo giá tiền tệ duy nhất",
    "bj": "Bảo đảm giá trong [**] ngày, không bao giờ giảm",
    "sybj": "Lợi nhuận [%] trong [**] ngày, cam kết giữ giá",
    "zk": "Ưu đãi VIP, mua sắm để kiếm tiền",
    "r": "Người",
    "lsxm": "Dự án lịch sử",
    "bpf": "Ngày không giảm giá trong 15 ngày, không thể giảm giá",
    "syybz": "Lợi nhuận được đảm bảo, giảm giá khi phát hành",
    "hg": "Quay lại VIP, giảm giá lớn khi mua sắm",
    "zgkx": "Giảm giá tối đa lên đến [**] [**]",
    "vip_zgkx": "Cấp VIP càng cao, giảm giá càng nhiều. Cấp VIP 6 cao nhất có thể giảm giá lên đến [**] [**]",
    "vip_zgkxNew": "Cấp VIP càng cao, giảm giá càng nhiều. Cấp VIP 6 cao nhất có thể giảm giá lên đến [**] [**]",
    "blsysj": "Thời gian còn lại của vòng này",
    "blqbqw": "Tất cả đã được mua sắm trong vòng này",
    "xyl": "Vòng tiếp theo",
    "zskq": "Mở cửa đúng giờ",
    "bljshs": "Còn lại cho đến khi mua sắm vòng này kết thúc",
    "zqyc": "Chỉ có thể mua sắm một lần mỗi vòng, hãy thử vòng tiếp theo!",
    "zxkf": "Bạn không có quyền tham gia sự kiện này, vui lòng liên hệ dịch vụ khách hàng để biết thêm chi tiết",
    "zqycNew": "Chỉ có thể hỗ trợ một lần mỗi vòng, hãy thử vòng tiếp theo!",
    "wed": "Số tiền có thể mua sắm của bạn cho dự án này là 0, hãy chú ý đến dự án tiếp theo",
    "wedNew": "Số tiền có thể hỗ trợ của bạn cho dự án này là 0, hãy chú ý đến dự án tiếp theo",
    "zsqg": "Số tiền mua tối thiểu là [**] [**], hãy mua sắm thêm",
    "srmm": "Vui lòng nhập mật khẩu giao dịch của bạn",
    "smrz": "Hãy hoàn thành xác minh danh tính KYC trước",
    "qszjymm": "Hãy đến cài đặt mật khẩu giao dịch trước",
    "wenjuandiaocha": "Bạn cần hoàn thành cuộc khảo sát trước khi tham gia sự kiện này",
    "scqgms": "Lễ hội BiKing FansUp!",
    "hxyh": "Hỗ trợ cộng đồng BiKing, thưởng thức nhiều phúc lợi",
    "zsqged": "Số tiền mua tối thiểu là [**] [**]",
    "zsqgedNew": "Số tiền hỗ trợ tối thiểu là [**] [**]",
    "wmtj": "Số lượng bạn đang giữ là [**], vui lòng mua sắm trước khi tham gia",
    "qjchqg": "Vui lòng mua sắm thêm trước khi mua sắm",
    "qjchqgNew": "Vui lòng mua sắm thêm trước khi hỗ trợ",
    "rgjg": "Giá mua sắm",
    "qqg": "Giảm giá",
    "wdqgjl": "Lịch sử tham gia của tôi",
    "ckxmxq": "Xem chi tiết dự án",
    "t": "Ngày",
    "yr": "Tháng [**] ngày [**]",
    "yrz": "Vòng [**] đang có sẵn",
    "qgz": "Vòng [**] đang mua sắm",
    "djlyjs": "Vòng [**] đã kết thúc",
    "dj": "Cấp VIP",
    "xszk": "Tỷ lệ giảm giá",
    "jgzked": "Số tiền giảm giá tham gia",
    "zked": "Số tiền giảm giá",
    "edw": "Ngoại trừ số tiền mua sắm tối thiểu, giá bình thường được thanh toán",
    "qbcczd": "Đảm bảo số lượng giữ chỗ của bạn lớn hơn 1000 CWT (số lượng mua tối thiểu)",
    "qrrjcc": "Số lượng giữ chỗ trung bình trong 7 ngày",
    "jlblks": "Thời gian còn lại cho đến khi bắt đầu vòng này",
    "jlbljs": "Thời gian còn lại cho đến khi kết thúc vòng này",
    "zgkqed": "Số tiền có thể mua sắm tối đa",
    "zgkzf": "Số tiền có thể thanh toán tối đa",
    "cggmsl": "Số lượng mua sắm bạn nhập vượt quá giới hạn",
    "bzzfzxgm": "Số lượng giữ chỗ hiện tại không đủ để thanh toán số lượng mua sắm tối thiểu",
    "bqzdqg": "Số tiền mua sắm tối thiểu là [**] [**]",
    "zlzcLower": "Số tiền hỗ trợ tối thiểu là [**], tối đa là [**]. Sau khi sự kiện kết thúc, số tiền hỗ trợ thu được sẽ được chuyển đến tài khoản của bạn trong vòng 5 ngày làm việc.",
    "zgqged": "Số tiền có thể mua sắm tối đa là [**] [**]",
    "yzbz": "Ưu đãi giảm giá cho các loại tiền tệ chất lượng cao, dành riêng cho Fan",
    "xszkj": "Giá giảm giá tạm thời",
    "zlbxsq": "Giảm giá tiền tệ chínhstream",
    "wks": "Chưa bắt đầu",
    "jxz": "Đang diễn ra",
    "qgsl": "Số lượng mua sắm",
    "wcydxm": "Dự án tôi đã tham gia",
    "bjq": "Kỳ đấu giá",
    "hgq": "Kỳ mua lại",
    "qzk": "Giảm giá",
    "qxzl": "Mua sắm đầu tiên để kiếm đồng token",
    "ds": "Giới hạn hỗ trợ",
    "dhbl": "Tỷ lệ đổi",
    "jicj": "Giá cơ bản",
    "jiagzd": "Giá cuối cùng sẽ được xác định trong vòng 3 giờ trước khi bắt đầu mua sắm",
    "zdyh": "Ưu đãi tối đa"
  };
  
  const hyy = {
    "bkt": "Không mở",
    "wqdkt": "Tôi xác nhận mở",
    "kt12": "1. Trước khi tham gia, bạn hãy đảm bảo đã hiểu rõ kiến thức cơ bản về giao dịch hợp đồng tiền điện tử và các rủi ro liên quan, cũng như các quy tắc kinh doanh liên quan đến giao dịch sản phẩm phái sinh.",
    "kt13": "2. Các mục rủi ro trong Tuyên bố này chỉ mang tính chất liệt kê và không thể liệt kê chi tiết tất cả các yếu tố rủi ro liên quan đến giao dịch sản phẩm phái sinh tài sản số; trước khi đầu tư vào giao dịch sản phẩm phái sinh tài sản số, bạn cũng nên cẩn thận tìm hiểu và nắm vững các yếu tố rủi ro khác có thể tồn tại.",
    "kt14": "3. Chúng tôi trân trọng khuyến khích và đề xuất các nhà đầu tư, dựa trên tình hình thực tế của bản thân như khả năng chịu đựng rủi ro, quyết định tham gia giao dịch hợp đồng này một cách thận trọng và phân bổ tài sản số của mình một cách hợp lý.",
    "kt0": "Người dùng thân mến:",
    "kt1": "Bạn chưa mở tài khoản hợp đồng và quyền giao dịch hợp đồng. Vui lòng đọc kỹ nội dung dưới đây trước khi quyết định mở:",
    "kt2": "1. Khi bạn giao dịch trên thị trường hợp đồng, nếu xu hướng giá thị trường không thuận lợi cho bạn và dẫn đến thiếu kinh phí bảo lãnh vị thế của bạn, hợp đồng vĩnh viễn của BiKing sẽ thực hiện lệnh bán tháo vị thế của bạn và tiết lộ chi tiết rõ ràng về việc bán tháo.",
    "kt3": "2. Bạn phải đọc và tuân thủ các quy tắc kinh doanh của hợp đồng vĩnh viễn của BiKing một cách cẩn thận, hiểu rõ cơ chế và nguyên lý hoạt động của hợp đồng, hiểu rõ mọi rủi ro trên thị trường.",
    "kt4": "4. Hợp đồng vĩnh viễn của BiKing kết nối hệ thống giao dịch hợp đồng. Lợi nhuận và lỗ nhuận từ vị thế của bạn thay đổi theo biến động của thị trường hợp đồng, và khi lỗ lớn, cũng sẽ xảy ra bán tháo trong hệ thống giao dịch hợp đồng. Xin hãy quyết định hành vi giao dịch của bạn theo tình hình thị trường và tự chịu trách nhiệm về lợi nhuận và lỗ nhuận.",
    "kt5": "5. Dưới một số điều kiện thị trường cực đoan, bạn có thể khó khăn hoặc không thể bán tháo hợp đồng chưa giải ngân. Ví dụ, khi lợi nhuận của bạn xếp hàng đầu trong toàn bộ PnL hiệu suất đòi hỏi và đối phương trong sàn không đủ tiền bảo hiểm để thanh toán số lỗ do phá sản.",
    "kt6": "6. Giao dịch sản phẩm phái sinh tài sản số có thể đối mặt với rủi ro giám sát chính trị trong một số lãnh thổ, và trước khi tham gia giao dịch, bạn cần thận trọng đưa ra quyết định dựa trên hiểu biết về bối cảnh giám sát chính trị tại địa điểm giao dịch. Do sự thay đổi về luật lệ, quy định và chính sách của quốc gia và khu vực liên quan, và thay đổi về quy tắc giao dịch của sàn giao dịch hợp đồng, BiKing sẽ công bố tuyên bố trước và lưu ý rằng các hợp đồng chưa giải ngân của bạn có thể không thể được duy trì sau khi kết thúc sự kiện, nhưng tài khoản và số lợi nhuận vẫn được giữ lại.",
    "kt7": "7. Vì lý do ngoại lực không thể kiểm soát được, chẳng hạn như: động đất, lụt, hỏa hoạn và các yếu tố không thể kiểm soát khác hoặc lỗi hệ thống máy tính, lỗi hệ thống truyền thông, bạn có thể không thể đặt lệnh của mình hoặc không thể thực hiện tất cả các giao dịch, và những thiệt hại do điều này có thể do bạn chịu trách nhiệm.",
    "kt8": "8. Giao dịch 'Giữ lãi' như là một lợi nhuận nhưng đồng thời mang lại những rủi ro từ biến động giá.",
    "kta9": "9. Nếu bạn chưa thực hiện xác minh danh tính hoặc chưa kết nối xác minh Google, hoặc nếu bạn chuyển giao tài khoản cho người khác sử dụng, có thể ảnh hưởng đến an toàn của tiền đặt cọc hợp đồng của bạn",
    "kta10":"10. Dưới một số điều kiện thị trường cực đoan, bạn có thể khó khăn hoặc không thể bán tháo hợp đồng chưa giải ngân. Ví dụ, khi lợi nhuận của bạn xếp hàng đầu trong toàn bộ PnL hiệu suất đòi hỏi và đối phương trong sàn không đủ tiền bảo hiểm để thanh toán số lỗ do phá sản.",
    "kt9": "Tôi đã đọc kỹ và sẵn lòng chấp nhận rủi ro",
    "kt10": "Mở tài khoản hợp đồng và quyền giao dịch hợp đồng",
    "zjhz": "Chuyển tiền",
    "ljhz": "Chuyển ngay",
    "qx": "Hủy chuyển",
    "khz": "Có thể chuyển",
    "qxz": "Chọn",
    "bz": "Loại tiền",
    "c": "Từ",
    "zz": "Đến",
    "sl": "Số lượng",
    "qb": "Toàn bộ",
    "ktcg": "Mở thành công",
    "ktsb": "Mở thất bại",
    "hzcg": "Chuyển thành công",
    "hzsb": "Chuyển thất bại",
    "wyyd": "", //Chưa chọn đã đọc bản nhắc nhở
    "tc": "Thoát",
    "warning1": "Vui lòng chọn loại tiền",
    "warning2": "Tài khoản chuyển ra không thể để trống",
    "warning3": "Tài khoản chuyển vào không thể để trống",
    "warning4": "Vui lòng nhập số không lớn hơn số có thể chuyển",
    "gb": "Đóng",
    "openSuccess": "Bạn đã mở giao dịch hợp đồng",
    "openSuccessTip": "Vui lòng chuyển tiền vào tài khoản hợp đồng",
    "warning5": "Giữ tối đa 4 chữ số thập phân",
    "not_get_nm": "Rất tiếc, hoạt động mã bùi đã kết thúc, chuyển giao lần này không nhận được mã bùi"
   };
  
  const trading = {
    "gflj": "Liên kết chính thức",
    "gw": "Trang chủ",
    "qkllq": "Trình duyệt khối",
    "scfxsj": "Thời gian phát hành lần đầu",
    "fxzl": "Tổng cung phát hành",
    "ltzl": "Tổng lưu hành",
    "jy": "Giao dịch",
    "sj": "Giá thị trường",
    "tbxx": "Thông tin biểu đồ",
    "bzgk": "Tổng quan về loại tiền",
    "ddb": "Bảng đặt hàng",
    "zxcj": "Giao dịch mới nhất",
    "reload": "Làm mới",
    "socketError": "Lỗi mạng, vui lòng",
    "noData": "Chưa có dữ liệu",
    "entrustorder": "Sổ lệnh",
    "prices": "Giá",
    "quantity": "Số lượng",
    "grandtotal": "Tổng cộng",
    "transamount": "Số tiền giao dịch",
    "time": "Thời gian",
    "available": "Khả dụng",
    "limitorder": "Giới hạn giá",
    "plancommission": "Lệnh kế hoạch",
    "currentcommission": "Lệnh đang chờ",
    "historycommission": "Lịch sử lệnh",
    "completecommission": "Lệnh đã thực hiện",
    "funds": "Quỹ",
    "hidetrading": "Ẩn các cặp giao dịch khác",
    "morecurrentcommission": "Thêm lệnh chờ hiện tại",
    "morehistorycommission": "Thêm lịch sử lệnh",
    "moredocommission": "Thêm lệnh đã thực hiện",
    "realtimetrans": "Giao dịch thời gian thực",
    "myassets": "Tài sản của tôi",
    "detail": "Chi tiết",
    "buyin": "Mua",
    "sellout": "Bán",
    "login": "Đăng nhập",
    "transfer": "Chuyển khoản",
    "recharge": "Nạp tiền",
    "withdrawal": "Mua tiền",
    "quickpurchase": "Mua tiền nhanh chóng bằng tiền tệ pháp",
    "default": "Mặc định",
    "ordertime": "Thời gian đặt lệnh",
    "tradingpair": "Cặp giao dịch",
    "direction": "Hướng",
    "types": "Loại",
    "commissionprice": "Giá đặt lệnh",
    "commissionnumber": "Số lượng đặt lệnh",
    "dealprice": "Giá trung bình giao dịch",
    "dealnumber": "Số lượng giao dịch",
    "triggerprice": "Giá kích hoạt",
    "cancelall": "Hủy tất cả",
    "averageprice": "Giá trung bình",
    "totalsum": "Tổng cộng",
    "fixedprice": "Giá cố định",
    "marketprice": "Giá thị trường",
    "codeExpired": "Mã QR đã hết hạn",
    "clickRefresh": "Nhấp để làm mới",
    "QRsuccessfully": "Quét mã thành công",
    "loginInApp": "Vui lòng xác nhận đăng nhập trong ứng dụng",
    "backtoQR": "Quay lại đăng nhập bằng mã QR",
    "loginSuccess": "Bạn đã đăng nhập thành công, BiKing chào mừng bạn!",
    "loadingText": "Đang tải...",
    "searchPlaceholder": "Tìm kiếm",
    "all": "Tất cả",
    "currency": "Loại tiền",
    "price": "Giá mới nhất",
    "market": "Danh sách tăng giảm",
    "increase": "Tăng giảm",
    "highestPrice": "Giá cao nhất",
    "minimumPrice": "Giá thấp nhất",
    "turnover": "Khối lượng giao dịch",
    "jydlb": "Danh sách các cặp giao dịch",
    "bzjs": "Giới thiệu về loại tiền",
    "currencyTransaction": "Giao dịch loại tiền",
    "leveragedTransaction": "Giao dịch đòn bẩy",
    "warning": "Cảnh báo rủi ro: Bitcoin Cash đang chia tách có độ không chắc chắn lớn, việc giao dịch hoặc đầu tư vào token tương lai trong giai đoạn chia tách có rủi ro lớn. Nếu một chuỗi không nhận được sự hỗ trợ từ các máy đào, có thể không thể tồn tại, đồng loại bạn giữ có thể có rủi ro về việc giảm giá xuống 0. BiKing không cam kết giá trị của bất kỳ token tương lai nào trong giai đoạn chia tách! ",
    "zb": "Chỉ số",
    "date": "Thời gian",
    "UpAnddown": "Tăng giảm",
    "amplitude": "Biên độ",
    "0": "Biểu đồ thời gian thực",
    "1": "1 phút",
    "5": "5 phút",
    "15": "15 phút",
    "30": "30 phút",
    "60": "1 giờ",
    "240": "4 giờ",
    "3600": "1 ngày",
    "10800": "1 tuần",
    "dates": "Kỳ hạn:",
    "password": "Mật khẩu giao dịch",
    "errorPassword": "Vui lòng nhập mật khẩu giao dịch chính xác",
    "worningPassword": "Vui lòng nhập mật khẩu giao dịch",
    "cancel": "Hủy",
    "sure": "Chắc chắn",
    "canBuy": "Mua được",
    "canCell": "Bán được",
    "withdraw": "Rút tiền",
    "otc": "OTC, rút tiền nhanh chóng bằng tiền tệ pháp",
    "enterPrice": "Vui lòng nhập giá",
    "sellingPrice": "Giá bán",
    "purchasePrice": "Giá mua",
    "salesVolume": "Lượng bán",
    "buyingVolume": "Lượng mua",
    "volume": "Khối lượng giao dịch",
    "serviceCharge": "Phí giao dịch",
    "vip": "Nâng cấp VIP, giảm giá phí giao dịch ngay",
    "or": "hoặc",
    "register": "Đăng ký",
    "totalPrice": "Khối lượng giao dịch không thể lớn hơn",
    "amountTip": "Vui lòng nhập số lượng chính xác",
    "amountTipError": "Số lượng không thể lớn hơn",
  
    "limitTrading": "Giao dịch giới hạn giá",
    "priceReminder": "Nhắc giá",
    "SMSReminder": "Nhắc SMS",
    "loginAccount": "Tài khoản đăng nhập",
    "phone": "Điện thoại",
    "phoneNum": "Vui lòng nhập số điện thoại",
    "phoneTips": "Vui lòng nhập số điện thoại chính xác",
    "email": "Email",
    "emailNum": "Vui lòng nhập email",
    "emailTips": "Vui lòng nhập email chính xác",
    "aears": "Vui lòng chọn mã khu vực",
    "passwordError": "Vui lòng nhập mật khẩu chính xác",
    "passwordTips": "Vui lòng nhập mật khẩu",
    "forgetPassword": "Quên mật khẩu",
    "noAccount": "Chưa có tài khoản",
    "goRegister": "Đăng ký ngay",
    "appsys": "Quét mã QR để đăng nhập một cách an toàn trong ứng dụng",
    "xzapp": "Tải về ứng dụng mới nhất",
    "mmdl": "Đăng nhập bằng mật khẩu",
    "smdl": "Đăng nhập bằng mã QR",
    "google": "Ứng dụng xác thực Google",
    "nybd": "Bạn đã liên kết thành công",
    "zqyzm": "Vui lòng nhập mã xác thực đúng",
    "fsyzm": "Gửi mã xác thực",
    "flv": "Phí giao dịch",
    "jz": "Giá trị ròng",
    "jzdesc1": "Giá trị dựa trên dựa trên thời điểm điều chỉnh trước đó *[1+3*(giá thị trường hiện tại - giá thị trường thời điểm điều chỉnh trước đó)/giá thị trường thời điểm điều chỉnh trước đó*100%]；",
    "jzdesc2": "Giá trị dựa trên thời điểm điều chỉnh trước đó *[1-3*(giá thị trường hiện tại - giá thị trường thời điểm điều chỉnh trước đó)/giá thị trường thời điểm điều chỉnh trước đó*100%]；",
    "sbd": "3 lần trở lên",
    "sbs": "3 lần trở xuống",
    "flvjs": 'Phí quản lý ETF, là tỷ lệ phí quản lý mà sàn thu thập hàng ngày từ số tiền đòn bẩy tương ứng để trả chi phí của danh mục quỹ. Phí quản lý sẽ phản ánh trong sự thay đổi của giá trị ròng, nghĩa là sẽ được thể hiện dưới hình thức "trừ giá trị của đòn bẩy ETF tương ứng". Phí quản lý sẽ được thu vào 0 giờ giờ Singapore hàng ngày và sẽ không tạo ra chi phí nếu bạn không giữ sản phẩm trong khoản thời gian đó.',
    "mzsm": "Tuyên bố miễn trừ trách nhiệm",
    "ido": "Tôi đã đọc và đồng ý",
    "exemption1": "Quý khách hàng thân mến, chào mừng bạn!",
    "exemption2": "Cảm ơn bạn đã đăng nhập và sử dụng sản phẩm ETF và dịch vụ liên quan do BiKing cung cấp (đây sau đây được gọi là “Sản phẩm ETF”). Hãy đọc kỹ Hướng dẫn Sản phẩm ETF và Cảnh báo rủi ro dưới đây. Nếu bạn tiếp tục sử dụng Sản phẩm ETF sau khi đọc xong, điều này sẽ được xem là bạn đã hiểu và đồng ý với tất cả nội dung của Cảnh báo rủi ro, có khả năng chấp nhận mọi rủi ro có thể phát sinh khi sử dụng Sản phẩm ETF và xem như bạn đồng ý với tất cả nội dung của tuyên bố miễn trừ trách nhiệm này. Hãy nhấp để đọc Hướng dẫn Sản phẩm ETF:",
    "exemption3": "FAQ về Sản phẩm ETF với đòn bẩy",
    "exemption4": "Cảnh báo rủi ro:",
    "exemption5": "1. Giá mua/bán của bạn không nên có sự chệch lệch đáng kể so với giá trị ròng đơn vị, nếu không bạn có thể phải chịu tổn thất tương ứng.",
    "exemption6": "2. Nếu đánh giá hướng sai, có rủi ro giá gần bằng 0 trong tình huống thị trường cực đoan.",
    "exemption7": "BiKing thân mời bạn lưu ý rằng, mọi tổn thất hoặc trách nhiệm phát sinh do rủi ro nêu trên đều là trách nhiệm của bạn, BiKing không chịu trách nhiệm về điều này. Tuyên bố miễn trừ trách nhiệm này, cùng với tất cả các thỏa thuận, tuyên bố và quy tắc khác trong BiKing, cùng nhau tạo nên sự thống nhất toàn bộ giữa bạn và BiKing về dịch vụ và sản phẩm của BiKing.",
    "bzjs1": "1. “3L” biểu thị giá của cặp giao dịch tăng 1%, giá trị ròng của sản phẩm này tăng 3%",
    "bzjs2": "2. “3S” biểu thị giá của cặp giao dịch giảm 1%, giá trị ròng của sản phẩm này tăng 3%",
    "bzjs3": "3. Giá trị ròng sẽ được điều chỉnh mỗi ngày vào 0 giờ và sẽ được điều chỉnh ngay lập tức trong trường hợp thị trường cực đoan",
    "bzjs4": "4. Phí quản lý tương ứng sẽ được tính theo ngày với mỗi đòn bẩy",
    "bzjs5": "5. Trước khi giao dịch, hãy chú ý kiểm tra giá trị ròng. Sản phẩm này có rủi ro giá tiệm cận với 0 trong tình huống thị trường cực đoan, có rủi ro nếu giá cách xa giá trị ròng. Vui lòng kiểm soát rủi ro.",
    "gdjk": "Xem thông báo để biết thêm chi tiết",
    firstTrading: "Trước khi thực hiện giao dịch lần đầu, hãy thiết lập mật khẩu giao dịch",
    status: "Trạng thái",
    status1: "Chờ khớp lệnh",
    status2: "Chưa thực hiện",
    status3: "Người dùng hủy bỏ",
    status4: "Một phần thực hiện",
    status5: "Thực hiện đầy đủ",
    status6: "Không hiệu quả",
    allCancel: "Hủy toàn bộ lệnh đặt hàng",
    canceld: "Hủy lệnh",
    cancelsuccess: "Hủy toàn bộ lệnh thành công, đã hủy [*] lệnh đặt hàng",
    VIP1: "Cấp độ VIP của bạn",
    VIP2: "Phí giao dịch thấp hơn, trải nghiệm giao dịch cao cấp hơn",
    VIP3: "Taker (Lệnh thị trường):",
    VIP4: "Maker (Lệnh giới hạn):",
    buyAmount: "Số lượng mua không được cao hơn",
    sellAmount: "Số lượng bán không được cao hơn",
    buyAmountMin: "Số dư mua có sẵn không đủ",
    sellAmountMin: "Số dư bán có sẵn không đủ",
  };
  
  const common = {
    wan: "nghìn",
    qian: "nghìn tỷ",
    yi: "tỷ",
  };
  const transferDialog = {
    amountLowTipError: "Số lượng không thể ít hơn",
    划转: "Chuyển khoản",
    资金互转: "Chuyển đổi vốn",
    币币账户: "Tài khoản giao dịch tiền điện tử",
    买币账户: "Tài khoản mua tiền điện tử",
    已冻结: "Đã đóng băng",
    合约账户: "Tài khoản hợp đồng",
    未开通: "Chưa mở",
    杠杆账户: "Tài khoản đòn bẩy",
    币贷宝账户: "Tài khoản Binance Earn",
    从: "Từ",
    转至: "Chuyển đến",
    币种: "Loại tiền",
    数量: "Số lượng",
    全部: "Toàn bộ",
    用户未归还借贷的情况下: "Trong trường hợp người dùng chưa trả nợ, có thể chuyển khoản số tiền có rủi ro với tỷ lệ rủi ro lớn hơn 200%",
    可划转: "Có thể chuyển khoản",
    一阶: "1. Bước một",
    累计净划入: "Tổng số tiền chuyển vào net",
    可获得: "Có thể nhận được",
    泥码: "Mã bùn",
    二阶: "2. Bước hai",
    您尚未完成实名认证: "Bạn chưa hoàn thành xác minh danh tính",
    余额: "Số dư",
    立即划转: "Chuyển ngay",
    资产划转: "Chuyển đổi tài sản",
    用于维持现有仓位的保证金: "Sử dụng để duy trì margin hiện tại",
    归还数量: "Số lượng trả nợ",
    您的币贷宝账户尚未开通: "Tài khoản Binance Earn của bạn chưa được mở, vui lòng mở trước",
    请输入正确的数量: "Vui lòng nhập số lượng đúng",
    划转金额不能为: "Số tiền chuyển khoản không thể là 0",
    账户可用余额不足: "Số dư khả dụng trong tài khoản không đủ",
    划转失败: "Chuyển khoản thất bại",
    划转成功: "Chuyển khoản thành công",
    本次划转未能获得泥码: "Rất tiếc, chương trình mã bùn đã kết thúc, chuyển khoản này không thể nhận được mã bùn",
    您只需再向合约账户划转: "Bạn chỉ cần chuyển thêm [*] USDT vào tài khoản hợp đồng để nhận được [**] USDT mã bùn",
    您向合约账户: "Bạn đã chuyển [*] USDT vào tài khoản hợp đồng,<br/>Tổng số chuyển net [*] USDT trở lên, sẽ nhận được",
    请输入划转数量: "Vui lòng nhập số lượng chuyển khoản",
  };
  export {
    state,
    subheader,
    purchase,
    purchaseCondition,
    historyProject,
    alipay,
    projectDetails,
    purchaseOver,
    myPurchase,
    mHeader,
    res,
    addContent,
    hyy,
    trading,
    common,
    transferDialog,
  };
  


// WEBPACK FOOTER //
// ./src/i18n/lang/vi.js